import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

const routes: Routes = [];

@NgModule({
  imports: [RouterModule.forChild([
    { path: 'empresa', data: { breadcrumb : 'Agenda' }, loadChildren: () => import('./agenda-empresa/agenda-empresa.module').then(m => m.AgendaEmpresaModule) },
    { path: 'configuracao', data: { breadcrumb : 'Configuração Agenda' }, loadChildren: () => import('./configurar-agenda/configurar-agenda.module').then(m => m.ConfigurarAgendaModule) },
  ])],
  exports: [RouterModule]
})
export class AgendaRoutingModule { }
